// Import directly from skills module to avoid circular dependency with @sol/sdk barrel export
import { ISkill } from "../skills";

export const getSkillTitle = (
    { code, officialTitle, shortTitle }: Pick<ISkill, "officialTitle" | "shortTitle" | "code">,
    long?: boolean,
) => `${code}. ${long ? officialTitle : shortTitle}`;
